<template lang="pug">
.input_container
  input(v-mask="'###'" type="text" @focus="onFocus1" @blur="onBlur1" v-model="value1" @input="returnValue" max="300" min="0" v-model.number="$parent.medData.systolic_pressure" :error="$parent.errors.medData.systolic_pressure")
  span /
  input(v-mask="'###'" type="text" @focus="onFocus2" @blur="onBlur2" v-model="value2" @input="returnValue" max="150" min="0" v-model.number="$parent.medData.diastolic_pressure" :error="$parent.errors.medData.diastolic_pressure")
  span мм рт. ст.
  button.delete(@click="clear" :tabindex="-1") ✖
  .hint(v-show="showHint1 && !noValid1") Введите значение в диапазоне: 0 - 300
  .hint(v-show="showHint2 && !noValid2") Введите значение в диапазоне: 0 - 150
  .error(v-if="noValid1 && this.value1 && this.value1.length") Введите значение Систолического АД в диапазоне: 0 - 300
  .error(v-if="noValid2 && this.value2 && this.value2.length") Введите значение Диастолического АД в диапазоне: 0 - 150
  .error(v-if="overlimit1 && this.value1 && this.value1.length") Максимальное количество символов 8. Введено - {{this.value1.length}}.
  .error(v-if="overlimit2 && this.value2 && this.value2.length") Максимальное количество символов 8. Введено - {{this.value2.length}}.
  .error(v-if="(this.value1 && !this.value2) || (!this.value1 && this.value2)") Необходимо заполнить оба значения
</template>
<script>
import { mask } from 'vue-the-mask'
export default {
  props: ['name', 'defaultValue1', 'defaultValue2'],
  data () {
    return {
      noValid1: false,
      noValid2: false,
      overlimit1: false,
      overlimit2: false,
      showHint1: false,
      showHint2: false,
      value1: this.defaultValue1,
      value2: this.defaultValue2
    }
  },
  directives: { mask },
  methods: {
    returnValue () {
      if (this.value1) this.$emit('input', this.value1)
      if (this.value2) this.$emit('input', this.value2)
    },
    clear () {
      this.showHint1 = false
      this.showHint2 = false
      this.noValid1 = false
      this.noValid2 = false
      this.overlimit1 = false
      this.overlimit2 = false
      this.value1 = null
      this.value2 = null
      this.$parent.medData.systolic_pressure = null
      this.$parent.medData.diastolic_pressure = null
      this.$store.dispatch('deleteError', this.name)
      this.$emit('input', this.value)
    },
    onBlur1 () {
      setTimeout(() => {
        if (this.value1 != null) {
          if (this.value1 && (this.value1 < 0 || this.value1 > 300 || isNaN(this.value1))) {
            this.noValid1 = true
            this.$store.dispatch('pushError', this.name)
          } else {
            this.noValid1 = false
          }

          if (this.value1.length >= 9) {
            this.overlimit1 = true
            this.$store.dispatch('pushError', this.name)
          } else {
            this.overlimit1 = false
          }
        }

        this.showHint1 = false
      }, 150)
    },
    onBlur2 () {
      setTimeout(() => {
        if (this.value2 != null) {
          if (this.value2 && (this.value2 < 0 || this.value2 > 150 || isNaN(this.value2))) {
            this.noValid2 = true
            this.$store.dispatch('pushError', this.name)
          } else {
            this.noValid2 = false
          }

          if (this.value2.length >= 9) {
            this.overlimit2 = true
            this.$store.dispatch('pushError', this.name)
          } else {
            this.overlimit2 = false
          }
        }

        this.showHint2 = false
      }, 150)
    },
    onFocus1 () {
      this.$store.dispatch('deleteError', this.name)
      this.showHint1 = true
    },
    onFocus2 () {
      this.$store.dispatch('deleteError', this.name)
      this.showHint2 = true
    }
  }
}
</script>
<style lang="sass" scoped>
.input_container
  display: grid
  grid-template-columns: 30% auto 30% auto 10%
  grid-template-rows: 2fr
  margin: 22px 20px 0 20px
input
  height: 30px
  border: 1px solid #ccc
  font-size: 16px
  color: #212121
  padding-left: 7px
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s
  outline: none
input:first-child
  border-radius: 4px 0px 0px 4px
input:focus
  border-radius: 4px 4px 4px 4px
  border-color: rgba(26, 163, 255, 0.8)
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(0, 153, 255, 0.6)
span
  border: 1px solid #ccc
  border-left: none
  display: grid
  font-size: 13px
  align-content: center
  justify-content: center
button
  border-radius: 0px 4px 4px 0px
  border: 1px solid #ccc
  border-left: none
  background: white
  display: grid
  align-content: center
  justify-content: center
  cursor: pointer
  outline: none
.delete:hover
  transition: all, .3s
  color: #e2211d
  font-weight: bold
button:hover
.error
  grid-column: 1 / 4
  color: #e53935
  margin-top: 4px
  margin-bottom: 4px
  font-size: 15px
.hint
  grid-column: 1 / 4
  color: #1d6c7a
  margin-top: 4px
  margin-bottom: 4px
  font-size: 15px
.input_error
  border-color: red
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(0, 153, 255, 0.6)
</style>
